import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [
  // Sync Menu
  nativeCommsMessageTypes.EXECUTE_SYNC
];
